import http from '@d-shared/http/http';

export default class AHttpService {
  constructor() {
    this._http = http;
  }
}
